import { deepSanitize } from '@fly/shared';
import axios, { InternalAxiosRequestConfig } from 'axios';

import { setupRetryInterceptor } from './interceptors';

export const createAxiosInstance = (
  baseURL: string,
  onRequest?: (config: InternalAxiosRequestConfig) => void
) => {
  const instance = axios.create({
    baseURL,
    timeout: 30000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.request.use((config) => {
    if (onRequest) {
      onRequest(config);
    }
    return config;
  });

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (config.data) {
      config.data = deepSanitize(config.data);
    }
    return config;
  });

  // Setup retry interceptor
  setupRetryInterceptor(instance);

  return instance;
};

const rawFlyApiV1Base = import.meta.env.VITE_APP_API_V1_URL;
const flyApiV1Base =
  typeof rawFlyApiV1Base === 'string'
    ? rawFlyApiV1Base.replace(/\/+$/, '')
    : rawFlyApiV1Base;

/** Same Fly v1 origin as {@link apiClientV1}, under `/myjfrog/<vertical>/`. */
export function createMyjfrogAxiosInstance(verticalPath: string) {
  return createAxiosInstance(`${flyApiV1Base}/myjfrog/${verticalPath}/`);
}

export const apiClientV1 = createAxiosInstance(flyApiV1Base);

/** BFF to my.jfrog usage APIs: `{flyApiV1Base}/myjfrog/usage/…`. */
export const myjfrogUsageApi = createMyjfrogAxiosInstance('usage');

/** BFF to my.jfrog billing reference: `{flyApiV1Base}/myjfrog/billing/reference/…`. */
export const myjfrogBillingReferenceApi =
  createMyjfrogAxiosInstance('billing/reference');

export const accessApiClientV1 = createAxiosInstance(
  import.meta.env.VITE_APP_ACCESS_API_V1_URL
);

export const registrationServiceApi = createAxiosInstance(
  import.meta.env.VITE_REGISTRATION_API_BASE_URL
);

export const userManagementApiClientV1 = createAxiosInstance(
  import.meta.env.VITE_USER_MANAGEMENT_API_BASE_URL
);
